import { tagArr, recipiesObj } from '../../data/recipesData'
import { get, onValue, set, ref } from 'firebase/database'
import { postsRef } from '../../firebase'

let recipesData = { ...recipiesObj }

onmessage = (message) => {
  if(message.data.type === 'updateRecipesData') {
    const payloadFromWorker = {
      type: 'updateRecipesData',
      recipesData: recipesData
    }

    postMessage(payloadFromWorker)
  }

  else if(message.data.type === 'updateSearchDataContext') {
    const tagsArray = tagArr
    const searchSuggesionsArray = []

    recipesData.recipes.forEach((item, i) => {
      recipesData.recipes[i].tags.forEach((tagItem) => {
        let index

        tagsArray.find((element, j) => {
          if(element.text.toLowerCase() === tagItem.toLowerCase()) {
            index = j
          }
        })

        if(index !== undefined)
          tagsArray[index].indexes.push(i)

        index = undefined

        searchSuggesionsArray.find((element, j) => {
          if(element.text.toLowerCase() === tagItem.toLowerCase()) {
            index = j
          }
        })

        if(index !== undefined)
          searchSuggesionsArray[index].indexes.push(i)

        else {
          searchSuggesionsArray.push({text: tagItem, indexes: [i]})
        }
      })
    })

    postMessage({type: 'updateSearchDataContext', tagsArray: tagsArray, searchSuggesionsArray: searchSuggesionsArray})
  }

  else if(message.data.type === 'updateRecipesValues') {
    //console.log("LOCAL STORAGE: " + JSON.stringify(message.data));

    recipesData.recipes.forEach((item, i) => {
      recipesData.recipes[i].numberOfLikes = message.data.postsData[recipesData.recipes[i].id].numberOfLikes
      recipesData.recipes[i].numberOfViews = message.data.postsData[recipesData.recipes[i].id].numberOfViews
      recipesData.recipes[i].isReacted = message.data.localStorageArray.some(item => item.indexOf(`recipeReact_${recipesData.recipes[i].id}`) === 0)
      recipesData.recipes[i].isPinned = message.data.localStorageArray.some(item => item.indexOf(`recipePin_${recipesData.recipes[i].id}`) === 0)
      recipesData.recipes[i].isSavedToWatchLater = message.data.localStorageArray.some(item => item.indexOf(`recipeSavedToWatchLater_${recipesData.recipes[i].id}`) === 0)
    })
    
    postMessage({type: 'updateRecipesData', recipesData: recipesData})
  }

  /*else if(message.data.type === 'updateRecipesLikesAndViews') {
    //recipesData = { ...message.data.recipesData }

    recipesData.recipes.forEach((item, i) => {
      const postId = recipesData.recipes[i].id

      if (message.data.postsData.hasOwnProperty(postId)) {
        recipesData.recipes[i].numberOfLikes = message.data.postsData[postId].numberOfLikes
        recipesData.recipes[i].numberOfViews = message.data.postsData[postId].numberOfViews
      }
    })

    postMessage({type: 'updateRecipesData', recipesData: recipesData})
  }

  else if(message.data.type === 'updateRecipeDataLikes' || message.data.type === 'updateRecipeDataViews') {
    //console.log("*******:: " + JSON.stringify());
    recipesData = { ...message.data.recipesData }

    if (message.data.type === 'updateRecipeDataLikes')
      recipesData.recipes[message.data.index].numberOfLikes = message.data.numberOfLikes

    else
      recipesData.recipes[message.data.index].numberOfLikes = message.data.numberOfLikes

    //recipesData.recipes[message.data.index].isReacted = message.data.isReacted

    postMessage({type: 'updateRecipesData', recipesData: recipesData})
  }*/
}
